import { render, staticRenderFns } from "./reportDetail.vue?vue&type=template&id=792b312e&scoped=true"
import script from "./reportDetail.vue?vue&type=script&lang=js"
export * from "./reportDetail.vue?vue&type=script&lang=js"
import style0 from "./reportDetail.vue?vue&type=style&index=0&id=792b312e&scoped=true&lang=css"
import style1 from "./reportDetail.vue?vue&type=style&index=1&id=792b312e&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792b312e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792b312e')) {
      api.createRecord('792b312e', component.options)
    } else {
      api.reload('792b312e', component.options)
    }
    module.hot.accept("./reportDetail.vue?vue&type=template&id=792b312e&scoped=true", function () {
      api.rerender('792b312e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/reportDetail.vue"
export default component.exports